const removeIneligibleChars = str =>
  str.replace(
    /[\s\t\r\nㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅑㅓㅕㅗㅛㅜㅠㅡㅣㅔㅖㅐㅘㅚㅙㅝㅟㅞㅢ]/g,
    ''
  );

// Remove ASCII special characters
const removeAsciiSpecialChars = str =>
  str.replace(/[\x20-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]/g, '');

// aaa -> aa
const reduceRepeatedLetters = str => str.replace(/(.)(?=\1\1)/g, '');

// ababab -> abab
const reduceRepeatedTwoLetters = str => str.replace(/(..)(?=\1\1)/g, '');

// abcabc -> abc
const removeRepeatedWords = str => str.replace(/(.{3,})(?=\1)/g, '');

const trimMessageForReward = inputMessage => {
  let message = inputMessage;
  message = removeIneligibleChars(message);
  message = removeAsciiSpecialChars(message);
  message = reduceRepeatedLetters(message);
  message = reduceRepeatedTwoLetters(message);
  message = removeRepeatedWords(message);
  return message;
};

export default trimMessageForReward;
